<script>
import { h } from 'vue';

export default {
    props: {
        show: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    setup({ show }, { slots }) {
        if (show) {
            return () => h(slots.default);
        }
        return () => h(slots.default()[0].children.default);
    },
};
</script>
